import { AgPublicEventType } from 'ag-grid-community';
import { LogAction } from './LogActions';

export enum LogSection {
  ACTIONS_PAGE = 'actions-page',
  ADVISOR_FEE_MODAL = 'advisory-fee-modal',
  ALERTS_SUMMARY_VISUAL = 'alerts-summary-visual',
  ALERTS_TABLE = 'alerts-table',
  APP_HEADER = 'app-header',
  APP_VIEW_HEADER = 'app-view-header',
  APP_VIEW_LEFT_PANEL = 'app-view-leftpanel',
  BULK_MODEL_EDITOR = 'bulk-model-editor',
  BULK_SECURITY_ANALYZER_HEADER = 'bulk-security-analyzer-header',
  COMPARISON_HEADER = 'comparison-header',
  DRAFTS_PAGE = 'drafts-page',
  EXHIBIT = 'exhibit',
  HOLDINGS_TABLE = 'holdings-table',
  INTERACTIVE_SCENARIOS_MODAL = 'interactive-scenarios-modal',
  INTERACTIVE_SCENARIOS_TAB = 'interactive-scenarios-tab',
  MODEL_CARD_FILTER = 'model-card-filter',
  MODEL_FAMILY_TABLE = 'model-family-table',
  MODEL_TABLE = 'model-table',
  MODELS_LIBRARY = 'models-library',
  NEW_ANALYSIS_PAGE = 'new-analysis-page',
  NEW_PROPOSAL = 'new-proposal',
  ORDER_DEEP_DIVE = 'order-deep-dive',
  PARTNER_PORTFOLIOS_MODAL = 'partner-portfolios-modal',
  PRIMARY_NAV = 'primary-nav',
  PROPOSAL_BUILDER_HEADER = 'proposal-builder-header',
  PROPOSAL_SETUP_MODAL = 'proposal-setup-modal',
  PROPOSAL_STATUS_MODAL = 'proposal-status-modal',
  PROPOSALS_ENGINE_WIZARD = 'proposals-engine-wizard',
  PROPOSALS_OVERVIEW = 'proposals-overview',
  PROSPECTS_TABLE = 'prospects-table',
  SAVE_REMINDER_MODAL = 'save-reminder-modal',
}

export enum LogView {
  CUSTOM_PORTFOLIOS = 'Custom Portfolios',
  DEEP_DIVE = 'DeepDive',
  MODEL_EVALUATOR = 'Model Evaluator',
  NEW_PROPOSAL = 'New Proposal',
  PROPOSAL_BUILDER = 'ProposalBuilder',
  PROSPECT_BUILDER = 'Prospect Builder',
}

// Used when you need to log localization tags and their translated values. Log them as <localizationTag>/<translatedValue>
export const LOGGER_TRANSLATION_DELIMITER = '/';

export enum LogElementMetadata {
  ACCOUNT = 'account',
  ACTIONS = 'actions',
  ACTIVE_VIEW_CHANGED = 'active-view-changed',
  ADD_PRODUCT_ACTIONS = 'add-product-actions',
  ADD_VIEW_OPTIONS = 'add-view-options',
  AGGREGATE = 'aggregate',
  AGGREGATE_VIEW_ACTIONS = 'aggregate-view-actions',
  ALERT_SNOOZE_OPTIONS = 'alert-snooze-options',
  ALERTS_FILTER_OPTIONS = 'alerts-filter-options',
  APP_HEADER = 'app-header',
  BATCH_RESOLUTION_OPTIONS = 'batch-resolution-options',
  BENCHMARK_OPTIONS = 'benchmark-options',
  BULK_ACTIONS_MENU = 'bulk-actions-menu',
  BULK_CURRENCY_OPTIONS = 'bulk-currency-options',
  BULK_SNOOZE_OPTIONS = 'bulk-snooze-options',
  CAMPAIGN_ACTIONS = 'campaign-actions',
  CARD_SEC_OPTIONS = 'card-sec-options',
  CARD_SETTINGS_OPTIONS = 'card-settings-options',
  CARD_TITLE_OPTIONS = 'card-title-options',
  CARD_VIEW_OPTIONS = 'card-view-options',
  CELL_RENDERER_OPTIONS = 'cell-renderer-options',
  COLLAPSE_DROPDOWN = 'collapse-dropdown',
  CREATE_NEW_ACTIONS = 'create-new-actions',
  CREATE_NEW_PROSPECT_MENU = 'create-new-prospect-menu',
  CURRENCY_OPTIONS = 'currency-options',
  DEEPDIVE_SNOOZE_OPTIONS = 'deepdive-snooze-options',
  DRAWER_ACTIONS = 'drawer-actions',
  DROP_DOWN = 'drop-down',
  EDIT_PROPOSAL_QUICK_ACTION = 'edit-proposal:quick-action',
  ENTITY_SEARCH_DROPDOWN_MENU = 'entity-search-dropdown-menu',
  EXTERNAL_LINK_MENU = 'external-link-menu',
  GENERIC_TABS_MENU = 'generic-tabs-menu',
  GROUPING_OPTIONS = 'grouping-options',
  HEADER = 'header',
  HEADER_CHECKBOX_OPTIONS = 'header-checkbox-options',
  HEADER_MENU = 'header-menu',
  HOLDINGS_QUICK_ACTIONS = 'holdings-quick-actions',
  HOLDINGS_TABLE_OPTIONS = 'holdings-table-options',
  HOUSEHOLDS_VIEW_SETS = 'households-view-sets',
  MODAL_OPTIONS = 'modal-options',
  MODAL_SAVE_REMINDER = 'save-reminder-modal',
  NESTED_GRP_BY = 'nested-grp-by',
  NEXT_STEP_ACTION = 'next-step-action',
  ORDER_EXHIBITS_OPTIONS = 'order-exhibits-options',
  ORDER_REVIEW_ACTIONS = 'order-review-actions',
  OVERFLOW_VIEW_TAB_OPTIONS = 'overflow-view-tab-options',
  PORTFOLIO_DATA_OPTIONS = 'portfolio-data-options',
  PORTFOLIO_OPTIONS = 'portfolio-options',
  PRIMARY_NAV_DROPDOWN_MENU = 'primary-nav-dropdown-menu',
  PRIMARY_NAV_GROUPED_MENU = 'primary-nav-grouped-menu',
  PROPOSAL_BUILDER = 'proposal-builder',
  PROPOSAL_REVIEW_ACTIONS = 'proposal-review-actions',
  PROPOSALS_ASSIGNMENT_OPTIONS = 'proposals-assignment-options',
  QUICK_ACTIONS = 'quick-actions',
  QUICK_FILTER_CARD = 'quick-filter-card',
  REALLOCATE = 'reallocate',
  REPORT_OPTIONS = 'report-options',
  SCENARIO_OPTIONS = 'scenario-options',
  SECURITY_FINDER_HEADER_OPTIONS = 'security-finder-header-options',
  SETTINGS_DROPDOWN = 'settings-dropdown',
  SETTINGS_DROPDOWN_MENU = 'settings-dropdown-menu',
  SETTINGS_MENU = 'settings-menu',
  SLEEVE = 'sleeve',
  SLEEVE_CONTRIBUTION_TOGGLE = 'sleeve-contribution-toggle',
  SUB_SLEEVE = 'sub-sleeve',
  TAB = 'tab',
  TAB_BAR_OPTIONS = 'tab-bar-options',
  TABLE_PICKER = 'table-picker',
  THEME_EDITOR_GROUP_BY = 'theme-editor-group-by',
  THEME_EDITOR_SORT_BY = 'theme-editor-sort-by',
  USER_OPTIONS = 'user-options',
  VIEW_CHANGED = 'view-changed',
  VIEW_SELECTOR_MENU = 'view-selector-menu',
  VIEW_SELECTOR_OPTION = 'view-selector-option',
  VIEW_SET_ACTIONS = 'view-set-actions',
  VIEW_SET_ACTIONS_GROUP = 'view-set-actions-group',
  VIEW_SET_CHANGED = 'view-set-changed',
  VIEW_SET_OPTIONS = 'view-set-options',
  VIEW_TAB_OPTIONS = 'view-tab-options',
  WORKFLOW_DATE = 'workflow-date',
}

export enum LogElementType {
  CHECKBOX = 'Checkbox',
  INPUT = 'Input',
  TAB = 'Tab',
}

export enum CustomLogAttribute {
  DISABLE_TRACKING = 'disable-tracking',
  TRACK_ACTION = 'track-action',
  TRACK_ELEMENT_METADATA = 'track-element-metadata',
  TRACK_ELEMENT_NAME = 'track-element-name',
  TRACK_METADATA = 'track-metadata',
  // Adobe Analytics specific attributes
  ADOBE_COMPONENT_NAME = 'data-adobe-component',
  ADOBE_LABEL = 'data-adobe-label',
  ADOBE_LINK_NAME = 'data-adobe-link-name',
  ADOBE_SUB_FIELD_NAME = 'data-adobe-sub-field',
  ADOBE_USER_ACTION = 'data-adobe-user-action',
}

export const DEBUG_ON_PARAM = 'debug';
export const LOGGER_CONTEXT_NAME = 'LoggerDataContext';
export const LOGGER_DEBOUNCE_TIME = 200;
export const AW_ADVISOR_APP_NAME = 'AWAdvisor';
export const MASKED_SENSITIVE_VALUE = 'sensitive';
export const ELEMENT_STATE_CHECKED = 'checked';
export const ELEMENT_STATE_UNCHECKED = 'unchecked';
export const ENV_DEV = 'dev';
export const ENV_PROD = 'prod';

export const GRIDEVENTS_STATIC: AgPublicEventType[] = ['cellClicked', 'cellKeyDown', 'sortChanged', 'rowGroupOpened'];
export const GRIDEVENTS_DYNAMIC = ['cellValueChanged', 'sortChanged', 'bodyScrollEnd'];

export const PROPOSAL_ENGINE_WIZARD_MODAL = 'modal:proposal-engine-wizard';

export const BATCH_PROPOSAL_ENGINE_WIZARD_MODAL = 'modal:batch-proposal-engine-wizard';

export const BACKGROUND_EVENTS_TAG = 'backgroundEvent';
export const BACKGROUND_EVENTS: Array<string> = [
  LogAction.HTTP_REQUEST,
  LogAction.HTTP_ERROR,
  LogAction.CLEARED_SP_ARRAY,
  LogAction.BROWSER_INFO,
  LogAction.API_CALL_FAILED_AFTER_RETRY,
  LogAction.API_CALL_SUCCEEDED_AFTER_RETRY,
  LogAction.NEW_DATES_AVAILABLE,
  LogAction.NEW_VERSION_AVAILABLE,
  LogAction.SENSITIVE_DATA_COPY_PASTED,
  LogAction.SENSITIVE_DATA_DETECTED,
  LogAction.SESSION_EXPIRY_REDIRECT_DETECTED,
  LogAction.FARO_INTEGRATION_SUCCESS,
  LogAction.FARO_INTEGRATION_FAILURE,
];
export const UNKNOWN = 'unknown';
// Component indicators for tracking
export const COMPONENT_INDICATORS = [
  'modal',
  'nav',
  'banner',
  'table',
  'form',
  'header',
  'footer',
  'sidebar',
  'panel',
  'card',
];
// Sub-field indicators for tracking
export const SUB_FIELD_INDICATORS = ['dropdown', 'menu', 'toolbar', 'tab'];
export const DOWNLOAD_ACTION_MATCH_TERMS = ['download', 'export'];
export const EXIT_ACTION_MATCH_TERMS = ['exit', 'close', 'abort', 'cancel'];

export const ADOBE_SITE_NAME = 'financial-professionals';
export const ADOBE_SITE_SECTION = 'tools';
export const DEFAULT_REPORT_SUITE_ID = 'blk-global-dev';
export const DEFAULT_OT_SCRIPT_ID = '1d844f07-6416-4f37-97e9-e7e8b80732f2-test';
export const DEFAULT_TEALIUM_PROFILE = 'financial-professionals';

export const MAX_LINK_NAME_LENGTH = 255;

export const SESSION_ID_STORAGE_KEY = 'aft.sessionId';
export const LAST_UNLOAD_TIME_STORAGE_KEY = 'aft.lastUnloadTime';
export const COMPARISON_IDS_KEY_FOR_ADOBE = 'comparisonIds';
export const PORTFOLIO_SELECTION_PATH = 'portfolio-selection';
export const COMPARISON_PATH = 'comparison';
export const NEW_ANALYSIS_PATH = 'new-analysis';
export const MODEL_EVALUATOR_PATH = 'model-evaluator';
export const TOOL_STATE_COMPLETE = 'Complete';
export const ADVISORY_FEE_KEY_FOR_ADOBE = 'advisoryFee';
export const ADVISORY_FEE_TOGGLE_KEY_FOR_ADOBE = 'isAdvisoryFeeToggleOn';
export const COMPARISON_JOURNEY_ACTIVE_KEY = 'comparisonJourneyActive';
export const ADOBE_DOMAIN_SPECIFIC_INFO_KEY = 'adobeDomainSpecificInfo';
export const BULK_SECURITY_ANALYZER_PATH = 'bulk-security-analyzer';
